import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ConfigStateService, DynamicLayoutComponent, ReplaceableComponentsService } from '@abp/ng.core';
import { LoaderBarComponent } from '@abp/ng.theme.shared';
import { NgxSpinnerComponent } from 'ngx-spinner';
import { catchError, EMPTY, exhaustMap, from, Subscription, timer } from 'rxjs';
import { SynchronizationManagerService } from './shared/services/synchronization-service';
import { OAuthService } from 'angular-oauth2-oidc';
import { eThemeLeptonXComponents } from '@volosoft/abp.ng.theme.lepton-x';

@Component({
  selector: 'app-root',
  template: `
    <abp-loader-bar />
    <abp-dynamic-layout />
    <ngx-spinner type="ball-clip-rotate" color="var(--energy-color)" />
  `,
  imports: [LoaderBarComponent, DynamicLayoutComponent, NgxSpinnerComponent],
})
export class AppComponent implements OnInit, OnDestroy {
  private autoSyncSubscription?: Subscription;
  private readonly replaceableComponents = inject(ReplaceableComponentsService);

  constructor(
    private readonly oauthService: OAuthService,
    private readonly config: ConfigStateService,
    private readonly synchronizationManager: SynchronizationManagerService,
  ) {
        this.replaceableComponents.add({
      component: null,
      key: eThemeLeptonXComponents.Settings,
    });
    this.replaceableComponents.add({
      component: null,
      key: eThemeLeptonXComponents.MobileNavbarSettings,
    });
    this.replaceableComponents.add({
      component: null,
      key: eThemeLeptonXComponents.Footer,
    });
  }

  ngOnInit() {
    this.startAutoSync();

    this.oauthService.events.subscribe(async event => {
      if (event.type === 'token_received' || event.type === 'token_refreshed') {
        this.startAutoSync();
      }

      if (event.type === 'logout' || event.type === 'token_refresh_error') {
        this.stopAutoSync();
      }
    });
  }

  ngOnDestroy(): void {
    this.stopAutoSync();
  }

  private startAutoSync(): void {
    if (this.autoSyncSubscription) {
      return;
    }

    this.autoSyncSubscription = timer(900000, 900000).pipe(
      exhaustMap(() => {
        const email = this.config.getDeep('currentUser.email');

        if (!email) {
          return EMPTY;
        }

        return from(this.synchronizationManager.syncAll(email)).pipe(
          catchError(error => {
            console.error('Auto sync failed', error);
            return EMPTY;
          })
        );
      })
    ).subscribe();
  }

  private stopAutoSync(): void {
    this.autoSyncSubscription?.unsubscribe();
    this.autoSyncSubscription = undefined;
  }
}
